export default __webpack_public_path__ + "static/media/Sorcerer's Bracers of Prestige.ae1bef8b.jpg";